import React from 'react';
import styled, { css } from 'styled-components';
import between from '../utils/media/between';
import only from '../utils/media/only';

const hidden = css`
    display: none !important;
`;

interface HiddenProps {
    children: React.ReactNode;
}

export const Desktop = styled.div<HiddenProps>`
    ${between('small', 'medium')} {
        ${hidden}
    }
`;

export const Mobile = styled.div<HiddenProps>`
    ${between('normal', 'large')} {
        ${hidden}
    }
    ${only('large')} {
        ${hidden}
    }
`;
